export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://llmdemo-backend-frdpdyhhbff9cndb.westus-01.azurewebsites.net' 
